import { motion, useReducedMotion } from "framer-motion";
import type { ReactNode } from "react";
import { cn } from "@/lib/utils";
import { publicPageReveal } from "@/lib/public-motion";

type PublicMotionMainProps = {
  children: ReactNode;
  className?: string;
  /** Altere ao trocar passo ou estado para repetir a entrada. */
  motionKey: string;
};

/**
 * Bloco principal com entrada (blur + movimento), alinhado ao feel de www/login.
 */
export function PublicMotionMain({
  children,
  className,
  motionKey,
}: PublicMotionMainProps) {
  const reducedMotion = useReducedMotion();

  return (
    <motion.div
      key={motionKey}
      className={cn("flex w-full flex-col items-center", className)}
      variants={publicPageReveal(reducedMotion)}
      initial="hidden"
      animate="visible"
    >
      {children}
    </motion.div>
  );
}
